import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.tos}/v1/tos`, {
  get: {
    'tos.features': '/feature'
  }
});
